import React from 'react';

export default function PolicyMessage() {
  return (
    <p className="check__text">
      Я соглашаюсь с{' '}
      <a
        target="_blank"
        className="link"
        href="https://tedo.ru/consent"
      >
        условиями обработки персональных данных
      </a>.{' '}
      Подробнее об обработке персональных данных – в{' '}
      <a
        target="_blank"
        className="link"
        href="https://tedo.ru/personal-data"
      >
        Политике
      </a>.
    </p>
  );
}
